//imports
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { clientQuery, clientMutation } from 'Core/data/GraphQLApi';
import { ExceptionManager } from 'Core/logManager';
import { endpoints } from 'Core/defaultValues';

//Action types
import {
    EVENT_CREATE_REQUEST,
    EVENT_EDIT_REQUEST,
    EVENT_GET_REQUEST,
    EVENT_GET_UNIT_TYPES_REQUEST
} from 'Redux/actionTypes';

//Actions
import {
    eventCreateResult,
    eventEditResult,
    eventGetResult,
    eventSearchUnitTypeResult,
    
} from 'Redux/actions';

function* getEvent({ payload }) {
    try {
        let QUERY = `
            query getEvent ($id: Int!) {
                result: getEvent (id: $id) {
                    id
                    name
                    color
                    diagnostic
                }
            }
        `;

        let data = yield call(
            clientQuery,
            QUERY,
            {
                id: payload
            },
            endpoints.GRAPHQL_GENERAL,
        );

        yield put(eventGetResult(data.result))

    } catch (exc) {
        yield put(eventGetResult())
        ExceptionManager(exc, 'Modules/events/views/.components/createEditEvent/redux/saga', 'getEvent');
    }
}

function* createEvent({ payload }) {
    try {
        let QUERY = `
            mutation createEvent ($name: String!, $color: String!, $diagnostic: Boolean) {
                result: createEvent (name: $name, color: $color, diagnostic: $diagnostic) {
                    id
                    name
                    color
                    diagnostic
                }
            }
        `;

        let data = yield call(
            clientMutation,
            QUERY,
            payload,
            endpoints.GRAPHQL_GENERAL,
        );

        if (data?.result) {
            yield put(eventCreateResult(data?.result))
        } else yield put(eventCreateResult())

    } catch (exc) {
        yield put(eventCreateResult())
        ExceptionManager(exc, 'Modules/events/views/.components/createEditEvent/redux/saga', 'createEvent', true);
    }
}

function* updateEvent({ payload }) {
    try {
        let QUERY = `
            mutation updateEvent ($id: Int!, $name: String!, $color: String!, $diagnostic: Boolean) {
                result: updateEvent (id: $id, name: $name, color: $color, diagnostic: $diagnostic) {
                    id
                    name
                    color
                    diagnostic
                }
            }
        `;

        let data = yield call(
            clientMutation,
            QUERY,
            payload,
            endpoints.GRAPHQL_GENERAL,
        );
        yield put(eventEditResult(data?.result));

    } catch (exc) {
        yield put(eventEditResult())
        ExceptionManager(exc, 'Modules/events/views/.components/createEditEvent/redux/saga', 'updateEvent');
    }
}

function* searchUnitTypeEvents({payload}){
    try {
        let QUERY = `
            query getEvent ($id: Int!) {
                result: getEvent (id: $id) {
                    id
                    name
                    color
                    diagnostic
                }
            }
        `;

        let data = yield call(
            clientQuery,
            QUERY,
            {
                id: payload
            },
            endpoints.GRAPHQL_GENERAL,
        );

        yield put(eventGetResult(data.result))
    } catch (exc) {
        yield put(eventSearchUnitTypeResult())
        ExceptionManager(exc, 'Modules/events/views/.components/createEditEvent/redux/saga', 'searchUnitTypeEvents');
    }
}

function* watchEventRequests() {
    yield takeEvery(EVENT_GET_REQUEST, getEvent);
    yield takeEvery(EVENT_CREATE_REQUEST, createEvent);
    yield takeEvery(EVENT_EDIT_REQUEST, updateEvent);
    yield takeEvery(EVENT_GET_UNIT_TYPES_REQUEST, searchUnitTypeEvents);
}

//Saga Export
export default function* rootSaga() {
    yield all([
        fork(watchEventRequests)
    ]);
}